'use client';

import { Link } from '@nextui-org/react';
import LogoInverse from './LogoInverse';

const Footer = () => {
  const menuItems = {
    about: [
      { label: 'For Patients', href: '/about/patients' },
      { label: 'For Providers', href: '/about/providers' },
      { label: 'For Biopharma', href: '/about/sponsors' },
      { label: 'Sponsors Directory', href: '/directory' },
      { label: 'Browse by Cancer Type', href: '/cancer-type' },
      { label: 'Social Impact', href: '/about/social-impact' },
    ],
    help: [
      { label: 'FAQ', href: '/about/faq' },
      { label: 'Contact Us', href: '/about/contact-us' },
      { label: 'Terms & Conditions', href: '/about/terms' },
      { label: 'Blog', href: '/blog/' },
      { label: 'Sitemap', href: '/about/sitemap' },
    ],
    contact: [{ label: 'contact@right2hope.org', href: 'mailto:contact@right2hope.org' }],
  };

  return (
    <footer className="bg-primary pt-16 pb-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-row gap-16 mb-12 flex-wrap">
          <div className="space-y-4">
            <LogoInverse size={50} />
            <p className="text-sm text-gray-200 max-w-xs">
              Right2Hope is a 501(c)(3) nonprofit organization dedicated to connecting patients with
              experimental treatments.
            </p>
          </div>

          <div>
            <h4 className="text-default-200 font-bold mb-4">About</h4>
            <ul className="space-y-2">
              {menuItems.about.map(item => (
                <li key={item.href}>
                  <Link href={item.href} className="text-white hover:opacity-70">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-default-200 font-bold mb-4">Help</h4>
            <ul className="space-y-2">
              {menuItems.help.map(item => (
                <li key={item.href}>
                  <Link href={item.href} className="text-white hover:opacity-70">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-default-200 font-bold mb-4">Contact</h4>
            <ul className="space-y-2">
              {menuItems.contact.map(item => (
                <li key={item.href}>
                  <Link href={item.href} className="text-white hover:opacity-70">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-default-200 pt-8 text-center">
          <p className="text-sm text-default-200">
            &copy; {new Date().getFullYear()} Right2Hope. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
